import React, {useEffect} from 'react'
import "../styles/home.css";
import Aos from 'aos';
import {FaGithub, FaTwitter, FaLinkedin, FaInstagram, FaFacebook, FaWhatsapp, FaEnvelope} from "react-icons/fa"; 
import { FaX, FaXTwitter } from 'react-icons/fa6';
 
 
 
const Home = () => {
   useEffect(() =>{
          Aos.init({
          duration: 1000, 
          easing: 'ease-in-out', 
          once: false,  
          offset: 100, 
          });
        }, [])

  const divStyle ={
    color: "var(--primary)",
    backgroundColor: "var(--accent)"
  }
  return (
    <div id='home'>
      {/* <Navbar /> */}
        <div className='home'>
            <p className='hi' data-aos ="fade-up">Hi, my name is</p>
            <p className='name' data-aos ="fade-up">John Glitse.</p>
            <p className='front-end' data-aos ="fade-up">Front-End Developer.</p>
            <p className='desc' data-aos ="fade-up">
             Think of me as a website's interior designer. I thrive on crafting dynamic, 
             human centric web and mobile experiences. 
            </p>
            {/* <p className='hi' data-aos ="slide-right">Hi, my name is</p>
            <p className='name' data-aos ="slide-right">John Glitse.</p>
            <p className='front-end' data-aos ="slide-right">Front-End Developer.</p>
            <p className='desc' data-aos ="slide-right">
              I build resposive web applications and 
                use-friendly mobile applications.
            </p> */}
            <div className='home-buttons' >
                <a href='#contact'><button className='home-button'>Let's talk</button></a>
                {/* <Button name="Let's Talk" />
                <Button name="Hire Me"></Button> */}
                <a href="mailto:glitsejohnray@gmail.com?subject=Hello&body=Send%20your%20%20CV%20%20to%20me.%20"
                   className='home-button' style={divStyle}>Resume</a>
                {/* <a href='John Glitse.pdf' download="John Glitse" className='home-button' style={divStyle}>Resume</a> */}
            </div>
            
        </div>
        
        <div className='icons'>
          <a href='https://github.com/JohnGlitse' target='_blank'><FaGithub className='icon github'/></a>
          <a href='https://www.linkedin.com/in/john-glitse-19310418a/' target='_blank'> <FaLinkedin className='icon linkedin'/></a>
          <a href='https://x.com/GlitseRay' target='_blank'><FaXTwitter className='icon twitter'/></a>
          <a href='https://www.instagram.com/johnrayglitse/' target='_blank'><FaInstagram className='icon instagram'/></a>
          <a href='https://www.facebook.com/johnray.glitse' target='_blank'><FaFacebook className='icon facebook'/></a>
          <a href=' https://wa.me/+233247423088' target='_blank'><FaWhatsapp className='icon whatsapp'/></a>
          <a href="mailto:glitsejohnray@gmail.com?subject=Hello&body=I'd%20like%20to%20get%20in%20touch%20with%20you.">
              <FaEnvelope className='icon email' /> 
            </a>
       </div>
        
    </div>
  )
}

export default Home
